/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class ClearData implements IDirective {
        public controller = ["$scope", "processConfigurationService", "formService", "objectSchemaService", ClearDataController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/clearData.html';
        public restrict: string = "E";

        public scope: any = {
            setDataOperation: "=",
            processConfigId: "=",
        };

        public link(scope: IClearDataScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            controller: ClearDataController): void {
        }
    }

    export interface IClearDataScope extends ng.IScope {
        setDataOperation: Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto;
        processConfigId: string;

        forms: Wars.Domain.Model.Form[];
        lists: Wars.Domain.Model.ObjectSchema[];
        fields: Wars.Domain.Model.SchemaProperty[];

        processDataLists: Wars.Domain.Model.ObjectSchema[];
        processDataFields: Wars.Domain.Model.SchemaProperty[];

        formSelectionChanged(): void;
    }

    export class ClearDataController implements IController {

        private isSystemLevel: boolean;

        constructor(
            private $scope: IClearDataScope,
            private processConfigurationService: services.ProcessConfigurationService,
            private formService: services.FormService,
            private objectSchemaService: services.ObjectSchemaService)
        {
            this.$scope.formSelectionChanged = () => this.formSelectionChanged();

            this.$scope.$watch('setDataOperation',
                () => {
                    this.setDataOperationChanged();
                });

            this.processConfigurationService.getProcessConfigurationWithForms(this.$scope.processConfigId)
                .then((processConfig) => {
                    this.$scope.forms = Enumerable.from(processConfig.myForms)
                        .where(i => i.formType !== Wars.Domain.Model.Codes.Enums.FormType.Manage)
                        .toArray();
                });

            if (this.$scope.setDataOperation.form_id) {
                this.setOptionsBasedOnSelectedForm();
            }

            this.processConfigurationService.getById(this.$scope.processConfigId).then(
                (processConfiguration) => {
                    if (processConfiguration.processDataSchema_id) {
                        this.objectSchemaService.getObjectSchemaExpanded(processConfiguration.processDataSchema_id).then(
                            (objectSchema) => {
                                this.$scope.processDataFields = Enumerable.from(objectSchema.properties)
                                    .where(i => i.typeSchema === null)
                                    .toArray()

                                this.$scope.processDataLists = Enumerable.from(objectSchema.properties)
                                    .where(i => i.typeSchema !== null)
                                    .select(i => i.typeSchema)
                                    .toArray();
                            });
                    }
                });
        }

        private setDataOperationChanged(): void {
            if (this.$scope.setDataOperation.form_id) {
                this.setOptionsBasedOnSelectedForm();
            }
        }

        private formSelectionChanged(): void {
            this.$scope.fields = [];

            this.$scope.setDataOperation.listObjectSchema_id = undefined;
            this.$scope.setDataOperation.fielSchemaProperty_id = undefined;

            if (!this.$scope.setDataOperation.form_id) {
                this.$scope.lists = [];
            } else {
                this.setOptionsBasedOnSelectedForm();
            }
        }

        private setOptionsBasedOnSelectedForm(): void {
            var selectedFormId = this.$scope.setDataOperation.form_id;
            this.formService.getFormConfiguration(selectedFormId)
                .then((form: Wars.Domain.Model.Form) => {
                    this.$scope.lists = Enumerable.from(form.mySteps)
                        .selectMany(i => i.formSections)
                        .where(i => i.objectSchema.isList)
                        .select(i => i.objectSchema)
                        .toArray();

                    this.$scope.fields = Enumerable.from(form.mySteps)
                        .selectMany(i => i.formSections)
                        .where(i => !i.objectSchema.isList)
                        .selectMany(i => i.fields)
                        .select(i => i.schemaProperty)
                        .toArray();
                });
        }
    }
}

warsApp.registerDirective('ClearData', []);